<template>
  <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img src="/img/bkgrnd.jpg" class="img-fluid">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                          <center><h1 style="color:white">Informatie verwerking</h1></center>
                        </div>
                    </div>
                </div>
            </div>

      </section>

      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5">
                              <p>Wij leggen uw gegevens vast ten behoeve van de organisatie van DevConf. Hiertoe delen we uw gegevens met <i>Event Insight</i>. Raadpleeg de Event Insight <u><a href="https://www.eventinsight.io/nl/privacy-verklaring">website</a></u> voor meer informatie.</p>
                              <p>Na het evenement bewaren wij naam, achternaam & e-mailadres alleen wanneer je hier tijdens het inschrijven expliciet toestemming voor geeft.</p>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>
  </div>
</template>

<script>
export default {
}
</script>
